import React, { useState } from 'react';
import { FinsightEntityField } from 'shared';

import { FieldEditor } from '../../components/FieldEditor';

export function FieldJSONGeneratorPage() {
  const [field, setField] = useState<FinsightEntityField['schema']>({
    type: 'string',
  });

  return <FieldEditor fieldName={'test'} field={field} setField={setField} />;
}
